import { v4 as uuidv4 } from 'uuid';

import { ISignersForm } from '../interfaces/ISignersForm';
import { ISigners } from '../../../APIPackage/KnmModule/interfaces/ISigners';
import { getSelectOption } from './getSelectOption';
import { DictionaryUUIDsEnum } from '../../../CorePackage/DictionariesModule/enums/DictionaryUUIDsEnum';
import { IRootState } from '../../../CorePackage/MainModule/interfaces/IRootState';
import { IKnmInspector248 } from '../../../APIPackage/KnmModule/interfaces/IKnmInspector248';
import { ISelectOption } from '../../../UIPackage/MainModule/components/SelectInput';

type SignerPositionDictionary = DictionaryUUIDsEnum.POSITIONS | DictionaryUUIDsEnum.PARTICIPANT_POSITIONS;

const getInspectorValue = (inspectors: IKnmInspector248[] | null | undefined, signer: ISigners) => {
  if (inspectors !== undefined) {
    const result = inspectors?.find(
      inspector =>
        inspector.fullName === signer.fioSigner &&
        inspector.position?.dictVersionId === signer.titleSigner?.dictVersionId,
    );

    if (result) {
      return result;
    }

    if (signer.fioSigner) {
      return {
        guid: '',
        fullName: signer.fioSigner,
      };
    }
  }

  return undefined;
};

export const convertSignersToFormValues = (
  values: ISigners[] | null | undefined,
  state: IRootState,
  inspectors: IKnmInspector248[] | null | undefined,
): ISignersForm[] | undefined => {
  if (!values) {
    return undefined;
  }

  return values.map(signer => {
    const dictUuid: SignerPositionDictionary | undefined =
      (signer.titleSigner?.dictId as SignerPositionDictionary) || undefined;

    const titleSignerSelectOption =
      dictUuid && signer.titleSigner
        ? getSelectOption<typeof dictUuid>(state, signer.titleSigner?.dictId, signer.titleSigner?.dictVersionId)
        : undefined;
    const inspectorValue = getInspectorValue(inspectors, signer);

    const signerFio: ISelectOption | string | undefined =
      (inspectorValue && (inspectorValue.guid || inspectors !== undefined)
        ? {
            id: inspectorValue.guid || '',
            label: inspectorValue.fullName,
            value: inspectorValue.fullName,
          }
        : signer.fioSigner) || undefined;

    const guid = signer.guid || uuidv4();

    const resultSigner: ISignersForm = {
      guid,
      fioSigner: signerFio,
      titleSigner: titleSignerSelectOption && {
        ...titleSignerSelectOption,
        inspectionResult: signer.titleSigner?.inspectionResult,
      },
      systemSignature: signer.systemSignature || undefined,
      signatureDateTime: signer.signatureDateTime || undefined,
      existedAtSigning: signer.existedAtSigning || undefined,
      listId: guid,
      isNew: !!signer.guid,
    };

    return resultSigner;
  });
};
